import { sendAnalytics } from '@audio-network/analytics'
import { Heading, Paragraph, TextLink } from '@audio-network/componentlibrary'
import { Sparkle } from '@audio-network/componentlibrary/icons'
import { useTranslation } from 'next-i18next'

import styles from './NoResultsPromptSearch.module.css'
import { NoResultsPromptSearchProps } from './NoResultsPromptSearch.types'

const NoResultsPromptSearch = ({
	query,
}: NoResultsPromptSearchProps): JSX.Element => {
	const { t } = useTranslation(['search'])

	const handleTryPrompt = (query: string): void => {
		sendAnalytics({
			noun: 'No Results Link',
			pastTenseVerb: 'Clicked',
			eventParameters: {
				Term: query,
			},
		})
	}

	return (
		<>
			<div className={styles.noResultsAiContainer}>
				<Sparkle className={styles.noResultsAiIcon} />
				<Heading level={2} size="S">
					{t('no-results-enhance-your-search')}
				</Heading>
				<Paragraph>
					{t('no-results-try-prompt-text')}
					<i>&quot;{query}&quot;</i> {t('no-results-try-prompt-as-a')}{' '}
					<TextLink
						href={`/track/searchkeyword?searchByPrompt=${encodeURIComponent(
							query
						)}`}
						onClick={() => handleTryPrompt(query)}
					>
						{t('no-results-try-prompt-link')}
					</TextLink>
				</Paragraph>
				<Paragraph className={styles.noResultsAiDescription}>
					{t('no-results-try-prompt-description')}
				</Paragraph>
			</div>
		</>
	)
}

export default NoResultsPromptSearch
